/**
 * @typedef {Object} ProductVariant
 * @property {string} key
 * @property {string} label
 * @property {number} price
 * @property {number} stock
 */
/**
 * @typedef {Object} Product
 * @property {string} id
 * @property {string} brand
 * @property {string} name
 * @property {string} category
 * @property {string} [subType]
 * @property {string[]} [subTypes]
 * @property {number} basePrice
 * @property {string} [tag]
 * @property {number} rating
 * @property {number} stock
 * @property {string} image
 * @property {ProductVariant[]} [variants]
 */

export const productData = [
  {
    id: "gpu-3060-palit",
    brand: "Palit",
    name: "RTX 3060 12GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 440000,
    tag: "Full Box",
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060-pny",
    brand: "PNY",
    name: "RTX 3060 12GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 440000,
    tag: "Full Box",
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060-evga-xc",
    brand: "EVGA XC",
    name: "RTX 3060 12GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 445000,
        rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060ti-palit-pny",
    brand: "Palit / PNY",
    name: "RTX 3060 Ti 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 450000,
        rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060ti-msi-ventus-x2",
    brand: "MSI Ventus X2",
    name: "RTX 3060 Ti 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 450000,
        rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060ti-gigabyte-eagle",
    brand: "Gigabyte Eagle Triple Fan",
    name: "RTX 3060 Ti 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 455000,
    tag: "Full Box",
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060ti-msi-ventus-x3",
    brand: "MSI Ventus X3",
    name: "RTX 3060 Ti 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 460000,
    tag: "Full Box",
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060ti-msi-gaming-x",
    brand: "MSI Gaming X",
    name: "RTX 3060 Ti 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 465000,
        rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060ti-gigabyte-oc",
    brand: "Gigabyte OC",
    name: "RTX 3060 Ti 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 470000,
    tag: "Full Box",
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3060ti-asus-rog-strix",
    brand: "ASUS ROG Strix",
    name: "RTX 3060 Ti 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 520000,
        rating: 4.8,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-zotac-gaming",
    brand: "Zotac Gaming",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 480000,
        rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-evga-xc3",
    brand: "EVGA XC3",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 500000,
        rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-msi-ventus-x3",
    brand: "MSI Ventus X3",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 505000,
    tag: "Full Box",
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-asus-tuf",
    brand: "ASUS TUF",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 515000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-zotac-twin-white",
    brand: "Zotac Twin White",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 515000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-asus-megalodon",
    brand: "ASUS Megalodon",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 515000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-gigabyte-vision",
    brand: "Gigabyte Vision",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 520000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-evga-ftw3-ultra",
    brand: "EVGA FTW3 Ultra",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 520000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3070-asus-rog-strix",
    brand: "ASUS ROG Strix",
    name: "RTX 3070",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 540000,
    rating: 4.8,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3080-pny-xlr8",
    brand: "PNY XLR8",
    name: "RTX 3080",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 630000,
        rating: 4.8,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3080-msi-ventus-oc",
    brand: "MSI Ventus OC",
    name: "RTX 3080",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 640000,
    tag: "Full Box",
    rating: 4.8,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3080-msi-ventus",
    brand: "MSI Ventus",
    name: "RTX 3080",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 685000,
    tag: "Full Box",
    rating: 4.8,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-3080-aorus-extreme",
    brand: "Aorus Extreme",
    name: "RTX 3080",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 710000,
    tag: "Full Box",
    rating: 4.8,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-2060-blower-turbo",
    brand: "Blower Turbo",
    name: "RTX 2060 6GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 270000,
        rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-2060-zotac",
    brand: "Zotac",
    name: "RTX 2060 6GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 325000,
        rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-2060-msi-ventus",
    brand: "MSI Ventus",
    name: "RTX 2060 6GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 325000,
        rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-2060-asus-dual",
    brand: "ASUS Dual",
    name: "RTX 2060 6GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 330000,
    tag: "Full Box",
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-2060s-battleaxe",
    brand: "Battleaxe",
    name: "RTX 2060 SUPER 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 315000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-2060s-msi-ventus-oc",
    brand: "MSI Ventus OC",
    name: "RTX 2060 SUPER 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 355000,
    tag: "Full Box",
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-2060s-msi-ventus",
    brand: "MSI Ventus",
    name: "RTX 2060 SUPER 8GB",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 380000,
    tag: "Full Box",
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-1660s-msi-ventus",
    brand: "MSI Ventus",
    name: "GTX 1660 SUPER",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 265000,
        rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-1660s-zotac-twin",
    brand: "Zotac Twin",
    name: "GTX 1660 SUPER",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 270000,
        rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-1660s-gigabyte",
    brand: "Gigabyte",
    name: "GTX 1660 SUPER",
    category: "Placas de Video",
    subType: "NVIDIA",
    basePrice: 270000,
        rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-sapphire-pulse",
    brand: "Sapphire Pulse",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 490000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-asrock-challenger",
    brand: "ASRock Challenger",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 490000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-asus-dual",
    brand: "ASUS Dual",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 495000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-xfx-quick",
    brand: "XFX Quick",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 495000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-msi-gaming-x",
    brand: "MSI Gaming X",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 500000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-powercolor-red-devil",
    brand: "PowerColor Red Devil",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 500000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-asus-tuf",
    brand: "ASUS TUF",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 505000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-sapphire-nitro",
    brand: "Sapphire Nitro",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 515000,
    rating: 4.7,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-6700xt-asus-rog-strix",
    brand: "ASUS ROG Strix",
    name: "RX 6700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 520000,
    rating: 4.8,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-msi-mech",
    brand: "MSI Mech",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 315000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-asus-tuf",
    brand: "ASUS TUF",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 315000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-asus-rog-strix",
    brand: "ASUS ROG Strix",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 325000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-gigabyte",
    brand: "Gigabyte",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 330000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-msi-gaming-x",
    brand: "MSI Gaming X",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 335000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-asrock-phantom",
    brand: "ASRock Phantom",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 335000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-xfx",
    brand: "XFX",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 335000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5700xt-sapphire-nitro",
    brand: "Sapphire Nitro",
    name: "RX 5700 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 350000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-5600xt-asrock-phantom",
    brand: "ASRock Phantom",
    name: "RX 5600 XT",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 270000,
    rating: 4.6,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "gpu-580-asrock-phantom-gaming",
    brand: "ASRock Phantom Gaming",
    name: "RX 580",
    category: "Placas de Video",
    subType: "AMD",
    basePrice: 190000,
    rating: 4.5,
    stock: 1,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
  },
  {
    id: "prod-7",
    brand: "WD",
    name: "SSD NVMe 1TB Gen4",
    category: "Almacenamiento",
    subType: "SSD",
    basePrice: 189900,
    rating: 4.8,
    stock: 15,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "gen4", label: "SSD NVMe 5000MB/s", price: 189900, stock: 9 },
      { key: "gen4-pro", label: "SSD NVMe 7000MB/s", price: 219900, stock: 6 },
    ],
  },
  {
    id: "prod-8",
    brand: "Seagate",
    name: "Disco HDD 2TB BarraCuda",
    category: "Almacenamiento",
    subType: "HDD",
    basePrice: 109900,
    rating: 4.5,
    stock: 11,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "hdd-2tb", label: "HDD 2TB", price: 109900, stock: 6 },
      { key: "hdd-4tb", label: "HDD 4TB", price: 169900, stock: 5 },
    ],
  },
  {
    id: "prod-9",
    brand: "Corsair",
    name: "Fuente 750W 80+ Gold",
    category: "Fuentes",
    basePrice: 239000,
    rating: 4.7,
    stock: 10,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "semi", label: "Semi Modular", price: 239000, stock: 6 },
      { key: "full", label: "Full Modular", price: 279000, stock: 4 },
    ],
  },
  {
    id: "prod-10",
    brand: "Kingston",
    name: "Memoria RAM Fury 16GB",
    category: "Memorias RAM",
    subTypes: ["DDR3", "DDR4", "DDR5", "SODIMM"],
    basePrice: 149900,
    rating: 4.7,
    stock: 18,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "ddr3", label: "DDR3 1600MHz", price: 109900, stock: 4 },
      { key: "ddr4", label: "DDR4 3200MHz", price: 149900, stock: 7 },
      { key: "ddr5", label: "DDR5 5600MHz", price: 219900, stock: 5 },
      { key: "sodimm", label: "SODIMM Notebook", price: 159900, stock: 2 },
    ],
  },
  {
    id: "prod-12",
    brand: "Apple",
    name: "iPhone 14",
    category: "iPhones",
    basePrice: 899000,
    rating: 4.7,
    stock: 6,
    image:
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "128gb", label: "128GB", price: 899000, stock: 3 },
      { key: "256gb", label: "256GB", price: 999000, stock: 3 },
    ],
  },
  {
    id: "prod-13",
    brand: "Apple",
    name: "iPhone 15",
    category: "iPhones",
    basePrice: 1099000,
    rating: 4.8,
    stock: 5,
    image:
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "128gb", label: "128GB", price: 1099000, stock: 2 },
      { key: "256gb", label: "256GB", price: 1199000, stock: 3 },
    ],
  },
  {
    id: "prod-14",
    brand: "Apple",
    name: "iPhone 16",
    category: "iPhones",
    basePrice: 1299000,
    rating: 4.9,
    stock: 4,
    image:
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "128gb", label: "128GB", price: 1299000, stock: 2 },
      { key: "256gb", label: "256GB", price: 1399000, stock: 2 },
    ],
  },
  {
    id: "prod-15",
    brand: "Apple",
    name: "iPhone 17",
    category: "iPhones",
    basePrice: 1499000,
    rating: 5.0,
    stock: 3,
    image:
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=600&auto=format&fit=crop",
    variants: [
      { key: "256gb", label: "256GB", price: 1499000, stock: 2 },
      { key: "512gb", label: "512GB", price: 1699000, stock: 1 },
    ],
  },
];

